import React, { useState, useEffect } from "react";
const ImageWithPlaceholder = ({
  item,
  className = "",
  placeholderClassName = "",
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const src = item?.product_image;
  const alt = item?.product_name;
  // console.log("Image Source:", src, alt);

  const firstLetter = item?.product_name?.charAt(0).toUpperCase();

  useEffect(() => {
    if (!src) {
      setImageError(true);
    }
  }, [src]);

  return (
    <>
      {!imageError ? (
        <img
          src={src}
          alt={alt}
          onError={handleImageError}
          className={`${className}`}
        />
      ) : (
        <div
          className={`
              ${placeholderClassName}
            `}
        >
          {firstLetter}
        </div>
      )}
    </>
  );
};

export default ImageWithPlaceholder;
